import { Controller } from "@hotwired/stimulus";

// Modern social-style community composer. Handles post type icons, member picker, preview.
export default class extends Controller {
  static targets = ["body", "postType", "memberIds", "bundlePreview", "postButton"];
  static values = {
    memberPickerUrl: String,
  };

  connect() {
    this.selectedMembers = [];
    this.postTypeValue = "regular";
    this.boundHandleMemberSave = this.handleMemberSave.bind(this);
    document.addEventListener("member-picker:save", this.boundHandleMemberSave);
    this.updatePostButton();
  }

  disconnect() {
    document.removeEventListener("member-picker:save", this.boundHandleMemberSave);
  }

  selectType(event) {
    const type = event.currentTarget.dataset.postType;
    this.postTypeValue = this.postTypeValue === type ? "regular" : (type || "regular");
    if (this.hasPostTypeTarget) {
      this.postTypeTarget.value = this.postTypeValue;
    }
    this.element.querySelectorAll("[data-post-type]").forEach((btn) => {
      const active = btn.dataset.postType === this.postTypeValue;
      btn.classList.toggle("bg-gray-200", active);
      btn.classList.toggle("dark:bg-gray-600", active);
      btn.classList.toggle("text-gray-900", active);
      btn.classList.toggle("dark:text-white", active);
    });
    this.updatePostButton();
  }

  onBodyInput() {
    this.updatePostButton();
  }

  handleMemberSave(event) {
    this.selectedMembers = event.detail?.members || [];
    const ids = this.selectedMembers.map((m) => m.id).join(",");
    if (this.hasMemberIdsTarget) {
      this.memberIdsTarget.value = ids;
    }
    this.renderBundlePreview();
    this.updatePostButton();
    document.dispatchEvent(new CustomEvent("drawer:close"));
  }

  renderBundlePreview() {
    if (!this.hasBundlePreviewTarget) return;
    if (this.selectedMembers.length === 0) {
      this.bundlePreviewTarget.innerHTML = "";
      this.bundlePreviewTarget.classList.add("hidden");
      return;
    }
    this.bundlePreviewTarget.classList.remove("hidden");
    const names = this.selectedMembers
      .slice(0, 3)
      .map((m) => m.name)
      .join(", ");
    const more = this.selectedMembers.length > 3 ? ` +${this.selectedMembers.length - 3} more` : "";
    this.bundlePreviewTarget.innerHTML = `
      <div class="flex items-center gap-2 flex-wrap">
        <div class="flex -space-x-2">
          ${this.selectedMembers
            .slice(0, 5)
            .map(
              (m, i) =>
                `<div class="w-6 h-6 rounded-full bg-primary-100 dark:bg-primary-900/50 flex items-center justify-center text-xs font-medium ring-2 ring-white dark:ring-gray-800" style="z-index: ${5 - i}; margin-left: ${i > 0 ? "-8px" : "0"}">${(m.name || "?")[0]}</div>`
            )
            .join("")}
        </div>
        <span class="text-sm text-gray-600 dark:text-gray-400">${names}${more}</span>
      </div>
    `;
  }

  updatePostButton() {
    if (!this.hasPostButtonTarget) return;
    const hasText = this.bodyTarget?.value?.trim().length > 0;
    const isBundle = this.postTypeValue === "bundle";
    const hasMembers = this.selectedMembers.length > 0;
    const canPost = hasText && (!isBundle || hasMembers);
    this.postButtonTarget.disabled = !canPost;
  }
}
